<template>
  <div class="pt-5" v-if="currentLanguage == 'en'" style="background-color: #F6F9FB;">
    <section class="pb-5">
      <div class="section-title text-center mb-5">
        <h1>Free Image Compressor Online</h1>
        <p>Compress images while maintaining HD quality</p>
      </div>
      <div class="tool">
        <image-resizer></image-resizer>
      </div>
    </section>

    <section class="help-section">
      <div class="help-header text-center">
        <h2 class="help-title">Image Compressor Guide and FAQs</h2>
        <p class="help-subtitle">Learn about SplendApp's image compression tool</p>
      </div>

      <nav class="tabs-nav" role="tablist" aria-label="Help topics">
        <button type="button" role="tab" id="image-compress-en-faq-tab" aria-controls="image-compress-en-faq-panel" :aria-selected="activeTab === 'faq'" :class="['tab-btn', activeTab === 'faq' ? 'active' : '']" @click="activeTab = 'faq'" @keydown.right.prevent="activeTab = 'guide'">
          Frequently Asked Questions
        </button>
        <button type="button" role="tab" id="image-compress-en-guide-tab" aria-controls="image-compress-en-guide-panel" :aria-selected="activeTab === 'guide'" :class="['tab-btn', activeTab === 'guide' ? 'active' : '']" @click="activeTab = 'guide'" @keydown.left.prevent="activeTab = 'faq'">
          Usage Guide
        </button>
      </nav>

      <!-- FAQ Pane EN -->
      <div v-show="activeTab === 'faq'" id="image-compress-en-faq-panel" role="tabpanel" aria-labelledby="image-compress-en-faq-tab" class="tab-pane">
        <div class="section-label">
          <span class="label-icon">⚙️</span> Technical Questions
        </div>
        <div
          v-for="(item, i) in enFaqTechnical"
          :key="'t'+i"
          class="faq-item"
          :class="{ open: openFaq === 'en-t-'+i }"
        >
          <div class="faq-question" @click="openFaq = openFaq === 'en-t-'+i ? null : 'en-t-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'en-t-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">📱</span> Usage & Saving
        </div>
        <div
          v-for="(item, i) in enFaqUsage"
          :key="'u'+i"
          class="faq-item"
          :class="{ open: openFaq === 'en-u-'+i }"
        >
          <div class="faq-question" @click="openFaq = openFaq === 'en-u-'+i ? null : 'en-u-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'en-u-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">⚖️</span> Rights & Ownership
        </div>
        <div
          v-for="(item, i) in enFaqRights"
          :key="'r'+i"
          class="faq-item"
          :class="{ open: openFaq === 'en-r-'+i }"
        >
          <div class="faq-question" @click="openFaq = openFaq === 'en-r-'+i ? null : 'en-r-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'en-r-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>
      </div>

      <!-- Guide Pane EN -->
      <div v-show="activeTab === 'guide'" id="image-compress-en-guide-panel" role="tabpanel" aria-labelledby="image-compress-en-guide-tab" class="tab-pane">
        <div class="search-box">
          <input
            type="text"
            v-model="guideSearch"
            placeholder="Search the usage guide..."
          >
          <span class="search-icon">🔍</span>
        </div>
        <div id="guideContent">
          <div v-for="(step, i) in filteredStepsEn" :key="i" class="step-card">
            <h3>{{ i + 1 }}. {{ step.title }}</h3>
            <p>{{ step.desc }}</p>
            <div class="snippet-placeholder">{{ step.placeholder }}</div>
          </div>
        </div>
        <p v-if="filteredStepsEn.length === 0" class="no-results">Sorry, no results found.</p>
      </div>
    </section>
  </div>

  <!-- ============ ARABIC ============ -->
  <div class="pt-5" style="direction: rtl; background-color: #F6F9FB;" v-else-if="currentLanguage == 'ar'">
    <section class="pb-5">
      <div class="section-title text-center mb-5">
        <h1>ضغط الصور أونلاين مجاناً</h1>
        <p>أداة سبيلنداب الذكية لضغط الصور مع الحفاظ على دقة الـ HD</p>
      </div>
      <div class="tool">
        <image-resizer></image-resizer>
      </div>
    </section>

    <section class="help-section">
      <div class="help-header text-center">
        <h2 class="help-title">دليل ضغط الصور والأسئلة الشائعة</h2>
        <p class="help-subtitle">تعرف على كيفية ضغط الصور وتقليل حجمها مع الحفاظ على الجودة</p>
      </div>

      <nav class="tabs-nav" role="tablist" aria-label="موضوعات المساعدة">
        <button type="button" role="tab" id="image-compress-ar-faq-tab" aria-controls="image-compress-ar-faq-panel" :aria-selected="activeTab === 'faq'" :class="['tab-btn', activeTab === 'faq' ? 'active' : '']" @click="activeTab = 'faq'" @keydown.right.prevent="activeTab = 'guide'">
          الأسئلة الشائعة
        </button>
        <button type="button" role="tab" id="image-compress-ar-guide-tab" aria-controls="image-compress-ar-guide-panel" :aria-selected="activeTab === 'guide'" :class="['tab-btn', activeTab === 'guide' ? 'active' : '']" @click="activeTab = 'guide'" @keydown.left.prevent="activeTab = 'faq'">
          دليل الاستخدام
        </button>
      </nav>

      <!-- FAQ Pane AR -->
      <div v-show="activeTab === 'faq'" id="image-compress-ar-faq-panel" role="tabpanel" aria-labelledby="image-compress-ar-faq-tab" class="tab-pane">
        <div class="section-label">
          <span class="label-icon">⚙️</span> أسئلة تقنية
        </div>
        <div
          v-for="(item, i) in arFaqTechnical"
          :key="'art'+i"
          class="faq-item"
          :class="{ open: openFaq === 'ar-t-'+i }"
        >
          <div class="faq-question" @click="openFaq = openFaq === 'ar-t-'+i ? null : 'ar-t-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'ar-t-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">📱</span> الاستخدام والحفظ
        </div>
        <div
          v-for="(item, i) in arFaqUsage"
          :key="'aru'+i"
          class="faq-item"
          :class="{ open: openFaq === 'ar-u-'+i }"
        >
          <div class="faq-question" @click="openFaq = openFaq === 'ar-u-'+i ? null : 'ar-u-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'ar-u-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>

        <div class="section-label">
          <span class="label-icon">⚖️</span> الحقوق والملكية
        </div>
        <div
          v-for="(item, i) in arFaqRights"
          :key="'arr'+i"
          class="faq-item"
          :class="{ open: openFaq === 'ar-r-'+i }"
        >
          <div class="faq-question" @click="openFaq = openFaq === 'ar-r-'+i ? null : 'ar-r-'+i">
            {{ item.q }}
            <span class="faq-toggle">{{ openFaq === 'ar-r-'+i ? '−' : '+' }}</span>
          </div>
          <div class="faq-answer">{{ item.a }}</div>
        </div>
      </div>

      <!-- Guide Pane AR -->
      <div v-show="activeTab === 'guide'" id="image-compress-ar-guide-panel" role="tabpanel" aria-labelledby="image-compress-ar-guide-tab" class="tab-pane">
        <div class="search-box">
          <input
            type="text"
            v-model="guideSearch"
            placeholder="ابحث في دليل الاستخدام..."
          >
          <span class="search-icon">🔍</span>
        </div>
        <div>
          <div v-for="(step, i) in filteredStepsAr" :key="i" class="step-card">
            <h3>{{ i + 1 }}. {{ step.title }}</h3>
            <p>{{ step.desc }}</p>
            <div class="snippet-placeholder">{{ step.placeholder }}</div>
          </div>
        </div>
        <p v-if="filteredStepsAr.length === 0" class="no-results">عذراً، لم نجد نتائج تطابق بحثك.</p>
      </div>
    </section>
  </div>
</template>

<script>
import ImageResizer from '@/components/ImageResizer.vue'
import ToolsComen from '@/components/ToolsComen.vue';
import ToolsComar from '@/components/ToolsComar.vue';

export default {
  name: 'ImageCompress',
  components: { ImageResizer, ToolsComen, ToolsComar },
  data() {
    return {
      currentLanguage: this.$store.state.currentLanguage,
      title: '',
      description: '',
      activeTab: 'faq',
      openFaq: null,
      guideSearch: '',

      // ─── Arabic FAQ Data ───────────────────────────────────────
      arFaqTechnical: [
        {
          q: 'هل يؤثر ضغط الصور على الجودة؟',
          a: 'قد يؤدي الضغط إلى فقد بسيط في التفاصيل حسب مستوى الجودة المختار. استخدم جودة عالية للحصول على أفضل توازن بين حجم الملف ووضوح الصورة.'
        },
        {
          q: 'ما صيغ الصور التي تدعمها الأداة؟',
          a: 'يمكنك رفع صور JPG وPNG وWebP، ثم اختيار WebP أو JPEG أو PNG كصيغة للصورة المضغوطة.'
        },
        {
          q: 'ما الحد الأقصى لحجم الصورة المرفوعة؟',
          a: 'تدعم الأداة صور JPG وPNG وWebP بحجم يصل إلى 20 ميجابايت للصورة الواحدة.'
        }
      ],
      arFaqUsage: [
        {
          q: 'هل يمكنني تغيير أبعاد الصورة أثناء الضغط؟',
          a: 'نعم، يمكنك تحديد العرض والارتفاع مع الحفاظ على تناسب أبعاد الصورة قبل تنزيل النسخة المضغوطة.'
        },
        {
          q: 'هل يمكنني ضغط أكثر من صورة في الوقت نفسه؟',
          a: 'تعالج الأداة صورة واحدة في كل مرة للحفاظ على سرعة المتصفح وإظهار مقارنة دقيقة بين الحجم الأصلي والمضغوط.'
        },
        {
          q: 'كيف أحفظ الصورة المضغوطة على جهازي؟',
          a: 'بعد اختيار الجودة والصيغة والأبعاد، اضغط على زر التحميل لحفظ الصورة المضغوطة مباشرة على جهازك.'
        },
        {
          q: 'هل تعرض الأداة مقدار تقليل حجم الملف؟',
          a: 'نعم، تعرض الأداة الحجم الأصلي والحجم المضغوط ونسبة التوفير قبل تنزيل الصورة.'
        }
      ],
      arFaqRights: [
        {
          q: 'هل توجد علامة مائية (Watermark) على الملفات؟',
          a: 'لا، نحن في سبلينداب نؤمن بدعم أصحاب المشاريع؛ لذا الملفات الناتجة خالية تماماً من أي علامات مائية وتخصك وحدك.'
        },
        {
          q: 'هل يمكنني استخدام الصور المضغوطة لأغراض تجارية؟',
          a: 'نعم، يمكنك استخدام الصور المضغوطة في موقعك أو متجرك الإلكتروني أو حسابات التواصل الاجتماعي وفق حقوقك في الصور الأصلية.'
        },
        {
          q: 'كيف تضمن الأداة خصوصية صوري؟',
          a: 'الأداة تعمل محلياً (Local) في المتصفح، مما يعني أن صورك لا تُرفع أبداً إلى أي خوادم، وتتم المعالجة بالكامل على جهازك.'
        }
      ],

      // ─── Arabic Guide Steps ────────────────────────────────────
      arGuideSteps: [
        {
          title: 'رفع الصورة',
          desc: 'اسحب صورة JPG أو PNG أو WebP إلى منطقة الرفع، أو اضغط لاختيار ملف بحجم يصل إلى 20 ميجابايت.',
          placeholder: '[لقطة شاشة: منطقة رفع الصورة]',
          keywords: 'رفع صورة ضغط JPG PNG WebP'
        },
        {
          title: 'اختيار جودة الضغط والصيغة',
          desc: 'اختر مستوى الجودة وصيغة الإخراج WebP أو JPEG أو PNG بما يناسب استخدام الصورة.',
          placeholder: '[لقطة شاشة: إعدادات الجودة وصيغة الإخراج]',
          keywords: 'جودة الضغط صيغة WebP JPEG PNG'
        },
        {
          title: 'ضبط أبعاد الصورة',
          desc: 'حدد العرض والارتفاع المطلوبين، واترك خيار الحفاظ على تناسب الأبعاد مفعلاً لتجنب تشويه الصورة.',
          placeholder: '[لقطة شاشة: إعدادات أبعاد الصورة]',
          keywords: 'تغيير الأبعاد العرض الارتفاع تناسب الصورة'
        },
        {
          title: 'التحميل النهائي',
          desc: 'راجع مقارنة الحجم الأصلي والمضغوط ونسبة التوفير، ثم اضغط على زر التحميل.',
          placeholder: '[لقطة شاشة: مقارنة الحجم وزر التحميل]',
          keywords: 'تنزيل الصورة المضغوطة نسبة التوفير'
        }
      ],

      // ─── English FAQ Data ──────────────────────────────────────
      enFaqTechnical: [
        {
          q: 'Does image compression reduce quality?',
          a: 'Compression may remove a small amount of detail depending on the selected quality. Choose High for the best balance between file size and visual clarity.'
        },
        {
          q: 'Which image formats does the tool support?',
          a: 'You can upload JPG, PNG, and WebP files and choose WebP, JPEG, or PNG for the compressed output.'
        },
        {
          q: 'What is the maximum upload size?',
          a: 'The tool accepts JPG, PNG, and WebP images up to 20MB per image.'
        }
      ],
      enFaqUsage: [
        {
          q: 'Can I resize the image while compressing it?',
          a: 'Yes. Set the target width and height and keep the aspect ratio enabled before downloading the compressed image.'
        },
        {
          q: 'Can I compress multiple images at once?',
          a: 'The compressor processes one image at a time so it can show an accurate original-versus-compressed comparison.'
        },
        {
          q: 'How do I save the compressed image?',
          a: 'Choose the quality, output format, and dimensions, then select Download to save the compressed image to your device.'
        },
        {
          q: 'Does the tool show how much file size was saved?',
          a: 'Yes. It displays the original size, compressed size, and percentage reduction before you download the image.'
        }
      ],
      enFaqRights: [
        {
          q: 'Is there a watermark on the output files?',
          a: 'No, at SplendApp we believe in supporting business owners, so output files are completely watermark-free and belong entirely to you.'
        },
        {
          q: 'Can I use compressed images for commercial purposes?',
          a: 'Yes. You can use the compressed output on websites, online stores, ads, or social media according to your rights in the original image.'
        },
        {
          q: 'How does the tool ensure my image privacy?',
          a: 'The tool works locally in the browser, meaning your images are never uploaded to any servers — all processing happens entirely on your device.'
        }
      ],

      // ─── English Guide Steps ───────────────────────────────────
      enGuideSteps: [
        {
          title: 'Upload an Image',
          desc: 'Drag a JPG, PNG, or WebP image into the upload area, or select a file up to 20MB.',
          placeholder: '[Screenshot: image upload area]',
          keywords: 'upload image compress JPG PNG WebP'
        },
        {
          title: 'Choose Quality and Format',
          desc: 'Choose the compression quality, output format, and target dimensions. Keep the aspect ratio enabled to avoid distortion.',
          placeholder: '[Screenshot: quality and output format settings]',
          keywords: 'compression quality output WebP JPEG PNG'
        },
        {
          title: 'Set Image Dimensions',
          desc: 'Enter the target width and height, and keep the aspect-ratio option enabled to prevent distortion.',
          placeholder: '[Screenshot: image dimension settings]',
          keywords: 'resize width height aspect ratio'
        },
        {
          title: 'Final Download',
          desc: 'Review the original and compressed sizes and the saving percentage, then select Download.',
          placeholder: '[Screenshot: size comparison and download button]',
          keywords: 'download compressed image size reduction'
        }
      ]
    }
  },

  computed: {
    filteredStepsAr() {
      if (!this.guideSearch) return this.arGuideSteps;
      const q = this.guideSearch.toLowerCase();
      return this.arGuideSteps.filter(s =>
        (s.title + s.desc + s.keywords).toLowerCase().includes(q)
      );
    },
    filteredStepsEn() {
      if (!this.guideSearch) return this.enGuideSteps;
      const q = this.guideSearch.toLowerCase();
      return this.enGuideSteps.filter(s =>
        (s.title + s.desc + s.keywords).toLowerCase().includes(q)
      );
    }
  },

  watch: {
    '$store.state.currentLanguage': function (newLanguage) {
      this.currentLanguage = newLanguage;
      this.openFaq = null;
      this.guideSearch = '';
      if (this.currentLanguage == 'en') {
        this.$router.push({ name: 'image-compress-en' });
      } else {
        this.$router.push({ name: 'image-compress-ar' });
      }
    }
  }
}
</script>

<style scoped lang='scss'>
p {
  font-size: 14px;
  color: #716c80;
}

.section-title {
  h2 {
    line-height: 1.4;
    margin-bottom: 0;
    font-size: 36px;
    font-weight: 700;
    color: #262A37;
  }
  p {
    font-size: 21px;
    color: #716c80;
    margin-bottom: 15px;
  }
}

// ── Help Section ─────────────────────────────────────────────────
.help-section {
  max-width: 900px;
  margin: 30px auto;
  margin-bottom: 0 ;
  padding: 20px;
  font-family: 'Cairo', sans-serif;
}

.help-header {
  margin-bottom: 40px;
}

.help-title {
  font-weight: 800;
  font-size: 2rem;
  color: #1e1b4b;
  margin-bottom: 8px;
}

.help-subtitle {
  color: #64748b;
  font-size: 14px;
}

// ── Tabs ──────────────────────────────────────────────────────────
.tabs-nav {
  display: flex;
  background: white;
  border-radius: 15px;
  overflow: hidden;
  margin-bottom: 25px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.tab-btn {
  flex: 1;
  padding: 18px;
  border: none;
  background: none;
  font-family: 'Cairo', sans-serif;
  font-weight: 700;
  cursor: pointer;
  transition: 0.3s;
  font-size: 1rem;
  color: #64748b;
  border-bottom: 3px solid transparent;

  &.active {
    color: #3a7afe;
    background: #fdfdff;
    border-bottom: 3px solid #3a7afe;
  }
}

.tab-pane {
  animation: fadeIn 0.4s ease;
}

// ── Section Labels ────────────────────────────────────────────────
.section-label {
  font-size: 1rem;
  font-weight: 700;
  color: #3a7afe;
  margin: 25px 0 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e2e8f0;

  .label-icon {
    margin-left: 6px;
    margin-right: 6px;
  }
}

// ── FAQ Items ─────────────────────────────────────────────────────
.faq-item {
  background: white;
  border-radius: 15px;
  margin-bottom: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
}

.faq-question {
  padding: 18px;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  color: #1e1b4b;
  font-size: 14px;
  transition: color 0.3s;

  .faq-toggle {
    font-size: 20px;
    color: #64748b;
    flex-shrink: 0;
    margin-right: 8px;
    margin-left: 8px;
    line-height: 1;
  }
}

.faq-answer {
  padding: 0 18px;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s ease-out, padding 0.3s;
  color: #64748b;
  font-size: 14px;
  line-height: 1.7;
}

.faq-item.open {
  .faq-question {
    color: #3a7afe;
  }
  .faq-answer {
    max-height: 300px;
    padding: 0 18px 18px;
  }
}

// ── Search Box ────────────────────────────────────────────────────
.search-box {
  position: relative;
  margin-bottom: 30px;

  input {
    width: 100%;
    padding: 15px 45px 15px 20px;
    border-radius: 12px;
    border: 2px solid #e2e8f0;
    font-family: 'Cairo', sans-serif;
    font-size: 1rem;
    box-sizing: border-box;
    outline: none;
    transition: 0.3s;
    color: #1e1b4b;

    &:focus {
      border-color: #3a7afe;
      box-shadow: 0 0 10px rgba(99, 102, 241, 0.1);
    }

    &::placeholder {
      color: #94a3b8;
    }
  }

  .search-icon {
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 1.1rem;
    pointer-events: none;
  }
}

// ── Step Cards ────────────────────────────────────────────────────
.step-card {
  background: white;
  padding: 25px;
  border-radius: 20px;
  margin-bottom: 20px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.02);
  border-right: 5px solid #3a7afe;

  h2 {
    margin-top: 0;
    font-size: 1.2rem;
    color: #3a7afe;
    font-weight: 700;
    margin-bottom: 10px;
  }

  p {
    margin-bottom: 0;
    color: #64748b;
    font-size: 14px;
    line-height: 1.7;
  }
}

.snippet-placeholder {
  background: #f1f5f9;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  margin: 15px 0 0;
  color: #94a3b8;
  font-size: 13px;
  display: none;
}

// ── No Results ────────────────────────────────────────────────────
.no-results {
  text-align: center;
  padding: 40px;
  color: #64748b;
  font-size: 14px;
}

// ── Animations ───────────────────────────────────────────────────
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}

// ── Existing styles ───────────────────────────────────────────────
.image {
  img { width: 100%; }
  max-width: 100%;
}

section .row { margin-top: 100px; }

.intro-video-content h2 {
  line-height: 1.4;
  color: #24365c;
  font-size: 48px;
  margin-bottom: 15px;
  font-weight: 700;
}

iframe {
  height: 400px;
  width: 100%;
  border-radius: 10px;
}

.single-features-item {
  background-color: white;
  transition: .5s;
  padding: 40px 30px 35px 110px;
  margin-bottom: 25px;
  border-radius: 5px;
  position: relative;
  z-index: 1;

  h3 { font-size: 20px; font-weight: 700; }

  &:hover {
    box-shadow: 0 50px 100px -20px rgba(50, 50, 93, .1), 0 30px 60px -30px rgba(107, 124, 147, .15);

    &::before { opacity: 1; visibility: visible; }
    a, h3, p { color: white; }
  }

  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0;
    width: 100%; height: 100%;
    border-radius: 5px;
    background: linear-gradient(44.44deg, #3a7afe .79%, #0053fe 94.18%);
    z-index: -1;
    opacity: 0;
    visibility: hidden;
    transition: .5s;
  }
}

@media (max-width: 769px) {
  .single-features-item { padding-left: 30px; }
  .help-section { padding: 10px; }
  .tab-btn { padding: 12px; font-size: 0.9rem; }
  .step-card { padding: 15px; }
  .help-title { font-size: 1.5rem; }
}

@media (min-width: 1400px) {
  .container, .container-lg, .container-md,
  .container-sm, .container-xl, .container-xxl {
    max-width: 1140px;
  }
}
</style>
